import type { JSX } from 'react';

import { Layout } from '../layout';

export function About(): JSX.Element {
	return <Layout />;
}
